export enum Flyer {
	E_ARCHIVE = 'eArchive',
	E_ARCHIVE_WORKPLACE = 'eArchive_workplace',
	E_ARCHIVE_INVITATION = 'eArchive_invitation',
	E_ARCHIVE_INVITATION_CHILDREN = 'eArchive_invitation_children',
	MEDDI_BABY_LATAM = 'meddi_baby_latam',
	MEDDI_DIABETES_LATAM = 'meddi_diabetes_latam',
}
